<script>
import { products } from '@/constants/launchpad';
import Socials from './SaleSocials';

export default {
  name: 'SaleTable',
  components: { Socials },
  data() {
    return {
      productsList: [],
    };
  },
  created() {
    this.productsList = Object.entries(products).filter((i) => i[1].isFinished);
  },
  methods: {
    getIconSrc(icon) {
      // eslint-disable-next-line global-require,import/no-dynamic-require
      return require(`../../assets/img/${this.$chain.getName()}/launchpad/${icon}.jpg`);
    },
  },
};
</script>

<template>
  <div class="sale-table">
    <div class="sale-table__title">
      <div>
        {{ $t('launchpad.table.name') }}
      </div>
      <div>
        {{ $t('launchpad.table.xxx') }}
      </div>
      <div>
        {{ $t('launchpad.table.roi') }}
      </div>
      <div>
        {{ $t('launchpad.table.socials') }}
      </div>
    </div>
    <div class="sale-table__wrapper">
      <div
        class="sale-table__row"
        v-for="(product, index) in productsList"
        :key="index"
      >
        <div>
          <router-link :to="`/tokensale/${product[0]}`" class="sale-table__name">
            <div class="sale-table__icon">
              <img :src="getIconSrc(product[1].icon)" :alt="product[1].name"/>
            </div>
            <div>
              {{ product[1].name }}
            </div>
          </router-link>
        </div>
        <div class="sale-table__param">
          <div>
            {{ $t('launchpad.table.xxx') }}
          </div>
          <div>{{ product[1].xxx }}x</div>
        </div>
        <div class="sale-table__param">
          <div>
            {{ $t('launchpad.table.roi') }}
          </div>
          <div>{{ product[1].roi }}</div>
        </div>
        <div class="sale-table__param sale-table__socials footer__social">
          <div>
            {{ $t('launchpad.table.socials') }}
          </div>
          <div>
            <Socials
              v-for="(item, index) in product[1].socialLinks.slice(0, 3)"
              :key="index"
              :social="item"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.sale-table {
  font-size: 2.4rem;
  font-weight: 600;

  &__title {
    text-align: right;
    margin-bottom: 2rem;
    display: flex;
    padding: 0 5rem;

    > div {
      flex-grow: 1;
      flex-basis: 0;

      &:first-child {
        text-align: left;
      }
    }

    @media screen and (max-width: $breakpoint-sm) {
      display: none;
    }
  }

  &__name {
    display: flex;
    align-items: center;
    min-width: 10rem;
  }

  &__wrapper {
    padding: 3rem 5rem;
    border-radius: $main-item-border-radius;
    background: $main-item-bg;
    box-shadow: $main-item-shadow;

    body.binance & {
      background: $b-main-item-bg;
      box-shadow: $b-main-item-shadow;
    }

    @media screen and (max-width: $breakpoint-sm) {
      padding: 0;
      background: transparent;
      box-shadow: none;
    }
  }

  &__icon {
    width: 5rem;
    height: 5rem;
    border-radius: 5rem;
    overflow: hidden;
    margin-right: 2rem;
    flex: none;

    img {
      width: 100%;
    }
  }

  &__row {
    display: flex;
    align-items: center;
    width: auto;

    > div {
      flex-grow: 1;
      flex-basis: 0;
    }

    &:not(:last-child) {
      margin-bottom: 2rem;
    }

    @media screen and (max-width: $breakpoint-sm) {
      align-items: flex-start;
      flex-direction: column;
      padding: 4rem 3rem;
      border-radius: $main-item-border-radius;
      background: $main-item-bg;
      box-shadow: $main-item-shadow;

      body.binance & {
        background: $b-main-item-bg;
        box-shadow: $b-main-item-shadow;
      }
    }
  }

  &__param {
    text-align: right;

    > div:first-child {
      display: none;
    }

    @media screen and (max-width: $breakpoint-sm) {
      display: flex;
      justify-content: space-between;
      width: 100%;
      margin-top: 2rem;

      > div:first-child {
        display: block;
      }
    }
  }

  &__socials {
    > div:nth-child(2) {
      font-size: 1.2rem;
      display: flex;

      @media screen and (max-width: $breakpoint-sm) {
        font-size: 0.8rem;

        a {
          margin-bottom: 0;
          margin-top: 0;
        }
      }
    }
  }
}
</style>
